import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { cartCount } = useCart();

  return (
    <nav className="navbar">
      <div className="nav-inner">
        <Link to="/" className="nav-logo">
          <img src="/v.png" alt="V2V Superfresh" className="logo-mark" />
          <div>
            <div className="brand">V2V <span>Superfresh</span></div>
            <div style={{ fontSize: 11, color: '#64748b', fontWeight: 500 }}>Farm to Apartment</div>
          </div>
        </Link>
        <div className="nav-actions">
          <Link to="/track" className="track-link">📍 Track Order</Link>
          <Link to="/cart" className="cart-btn">
            🛒 Cart
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
